import { render, staticRenderFns } from "./V2ColorPicker.vue?vue&type=template&id=1c071ce2&scoped=true&"
import script from "./V2ColorPicker.vue?vue&type=script&lang=js&"
export * from "./V2ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./V2ColorPicker.vue?vue&type=style&index=0&id=1c071ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c071ce2",
  null
  
)

export default component.exports